import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";

export async function mta(path, method = "GET", body, signal) {
  const response = await doFetch("MTA", path, {
    method, signal, _silent: true,
    headers: { "Content-Type": "application/json" },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  if (!response) throw new Error("No hay conexión con el servidor. Puedes volver a intentarlo.");
  let result;
  try { result = await response.json(); } catch (_) { throw new Error(`Respuesta no válida (${response.status})`); }
  if (!response.ok || result.STATE !== "SUCCESS") {
    const error = new Error(response.status === 401 ? "Tu sesión ha caducado." : response.status === 403 ? "No tienes acceso a esta acción." : result.MESSAGE || "No se pudo completar la operación.");
    error.status = response.status;
    throw error;
  }
  return result.DATA;
}

export const localZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export function localInput(value) {
  if (!value) return "";
  const date = new Date(value);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
}

// Preserve the local offset: the server checks it against the supplied IANA zone.
// Reject DST gaps instead of silently moving the user's selected time.
export function offsetDate(value) {
  const date = new Date(value);
  if (!value || !Number.isFinite(date.getTime()) || localInput(date) !== value) throw new Error("Horario inexistente o no válido en tu zona horaria.");
  const offset = -date.getTimezoneOffset();
  return `${value}:00${offset >= 0 ? "+" : "-"}${String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0")}:${String(Math.abs(offset) % 60).padStart(2, "0")}`;
}
export function scheduleOf(form) {
  if (form.allDay) {
    if (!form.startDate || !form.endDateExclusive || form.startDate >= form.endDateExclusive) throw new Error("El día final (exclusivo) debe ser posterior al inicial.");
    return { kind: "ALL_DAY", startDate: form.startDate, endDateExclusive: form.endDateExclusive, timeZone: form.timeZone || localZone() };
  }
  const start = offsetDate(form.start), end = offsetDate(form.end);
  if (new Date(start) >= new Date(end)) throw new Error("El final debe ser posterior al inicio.");
  return { kind: "TIMED", start, end, timeZone: localZone() };
}
export const displayTime = value => value ? new Date(value).toLocaleString("es-ES", { dateStyle: "medium", timeStyle: "short" }) : "Sin horario";
export const states = { DRAFT: "Borrador", PLANNING: "Planificación", CONFIRMED: "Confirmado", IN_PROGRESS: "En curso", COMPLETED: "Completado", CANCELLED: "Cancelado" };
